export const SET_LOADING_DATA = '@ratings/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@ratings/SET_LOADING_SELECTS';

export const GET_ALL_REQUEST = '@ratings/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@ratings/GET_ALL_SUCCESS';

export const GET_FILTER_REQUEST = '@ratings/GET_FILTER_REQUEST';
export const GET_FILTER_SUCCESS = '@ratings/GET_FILTER_SUCCESS';

export const GET_ALL_SELECTS_REQUEST = '@ratings/GET_ALL_SELECTS_REQUEST';
export const GET_ALL_SELECTS_SUCCESS = '@ratings/GET_ALL_SELECTS_SUCCESS';

export const SHARE_CSV = '@ratings/SHARE_CSV';

export const SET_PAGE = '@ratings/SET_PAGE';
export const SET_ROWS_COUNT = '@ratings/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@ratings/SET_ROWS_PER_PAGE';
export const SET_ROWS_ORIENTATION = '@ratings/SET_ROWS_ORIENTATION';
export const SET_ORDER = '@ratings/SET_ORDER';
export const SET_ORDERBY = '@ratings/SET_ORDERBY';

export const SEARCH = '@ratings/SEARCH';
